import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import { plugin, defaultConfig } from '@formkit/vue'
import { createHead } from '@vueuse/head'
import VueYoutube from 'vue3-youtube'
import '/src/assets/css/index.css'

const myBarredOwlApp = createApp(App)
const head = createHead()

myBarredOwlApp
	.use(head)
	.use(plugin, defaultConfig)
	.component('Youtube', VueYoutube)
	.use(router)

myBarredOwlApp.mount('#app')